import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';

import { history } from '_helpers';
import { mealPlanActions, alertActions } from '_store';

export { AddEdit };

function AddEdit() {
    const { selectedDate } = useParams();
    const [title, setTitle] = useState();
    const dispatch = useDispatch();
    const mealPlan = useSelector(x => x.mealPlans?.item);

    // form validation rules 
    const validationSchema = Yup.object().shape({
        date: Yup.string()
            .required('Date is required'),
        mealName: Yup.string()
            .required('Meal name is required'),
    });
    const formOptions = { resolver: yupResolver(validationSchema) };

    // get functions to build form with useForm() hook
    const { register, handleSubmit, reset, formState } = useForm(formOptions);
    const { errors, isSubmitting } = formState;

    useEffect(() => {
        setTitle('Meal Plan Day');
        
        dispatch(mealPlanActions.getMealPlan(selectedDate)).unwrap()
            .then(mealPlan => reset(mealPlan));
    }, []);

    async function onSubmit(data) {
        dispatch(alertActions.clear());
        try {
            await dispatch(mealPlanActions.setMeal(data)).unwrap();
            let message = 'Meal Saved';

            history.navigate('/mealPlans');
            dispatch(alertActions.success({ message, showAfterRedirect: true }));
        } catch (error) {
            dispatch(alertActions.error(error));
        }
    }

    return (
        <>
            <h1>{title}</h1>
            {!(mealPlan?.loading || mealPlan?.error) &&
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                        <div className="mb-3 col">
                            <label className="form-label">Meal Date</label>
                            <input name="date" type="date" {...register('date')} className={`form-control ${errors.date ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.date?.message}</div>
                        </div>
                        <div className="mb-3 col">
                            <label className="form-label">Meal Name</label>
                            <input name="mealName" type="text" {...register('mealName')} className={`form-control ${errors.mealName ? 'is-invalid' : ''}`} />
                            <div className="invalid-feedback">{errors.mealName?.message}</div>
                        </div>
                    </div>
                    <div className="mb-3">
                        <button type="submit" disabled={isSubmitting} className="btn btn-primary me-2">
                            {isSubmitting && <span className="spinner-border spinner-border-sm me-1"></span>}
                            Save
                        </button>
                        <button onClick={() => reset()} type="button" disabled={isSubmitting} className="btn btn-secondary">Reset</button>
                        <Link to="/mealPlans" className="btn btn-link">Cancel</Link>
                    </div>
                </form>
            }
            {mealPlan?.loading &&
                <div className="text-center m-5">
                    <span className="spinner-border spinner-border-lg align-center"></span>
                </div>
            }
            {mealPlan?.error &&
                <div class="text-center m-5">
                    <div class="text-danger">Error loading meal Plan: {mealPlan.error}</div>
                </div>
            }
        </>
    );
}